import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar",
  "use": "calendar-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"calendar\"><g fill=\"none\" fill-rule=\"evenodd\"><path /><g fill=\"var(--bolt-theme-icon, currentColor)\"><path d=\"M4 20.1h16v-11H4v11zM20 2.6h-1V1h-2v1.6H7V1H5v1.6H4a2 2 0 00-2 2v15.5c0 1.1.9 2 2 2h16a2 2 0 002-2V4.6a2 2 0 00-2-2zM6.3 13.1h11.4v-2H6.3zM6.3 17.5h9v-2h-9z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol